<template>
<div>
	<div  :class="ccss"></div>
	<div class="modal fade" ref="modall"  style="z-index: 9999; position:fixed" role="dialog">
		<div class="iphone-x-top"></div>
		<div class="modal-dialog"  :style="{'max-width':_isMobile ? '95%' : width }">

			<div class="modal-content" >
				<div v-if="header" class="modal-header" style="background:#DDD">
					<h5 class="modal-title"><slot name="header"></slot></h5>

					<a href="#" class="fechar-modal" @click.prevent="modal.hide()" style="margin:-0.5rem -0.5rem -1rem auto">
						<fa-icon icon="times"/>
					</a>
				</div>
				<div class="modal-body" :style="{'padding': padding}">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>
import _ from 'lodash'
import  {Modal}  from '../../library/boostrap-native-v4'
export default {

    props: {
        padding: {
            required: false,
            type: String,
            default: '15px',
		},

		backdrop: {
			required: false,
			default: 'static'
		},

        header: {
            required: false,
            type: Boolean,
            default: true,
        },

        width: {
            required: false,
            type: String,
            default: '60%',
        },
    },

    data() {
        return {
            time: null,
            timeClose: null,
            classes: 'fadeIn',
			classeConteudo: '',
			modal: null,
			action: null,
			ccss: null,
        }
    },

    methods: {

        show(time){
            clearTimeout(this.time)
			this.time = null

            if(_.isNumber(time)){
                if(time > 0){
                    this.time = setTimeout(() => {
                        this.hide()
                    }, time);
                }
			}

			let options = {
				backdrop: this.backdrop,
				keyboard: false
			}

			this.modal = new Modal(this.$refs.modall, options);

			this.ccss = 'modal-backdrop show'

			this.modal.show()

			this.$refs.modall.addEventListener('hide.bs.modal', (event) => {
				this.ccss = null
				this.$emit('modal-hide', this.action)
			}, false);
        },

        hide(action){
			this.action = action
			this.modal.hide()
            clearTimeout(this.time)
        }
    },

}
</script>





// WEBPACK FOOTER //
// src/components/modal/main.vue